export default __webpack_public_path__ + "mother-at-yarisi.svg";